export default class FakeNews {
  static getFakeNewsContent() {
    if (window?.API?.['fake-news']) {
      return window.API['fake-news'];
    }
    return {
      title: 'Accueil',
      decoding: {
        title: 'Bienvenue dans fake news decrypt',
        nodes: {
          96: {
            title: 'La structure du VIH et son cycle de réplication',
            thumbnail: 0,
            link: '/la-structure-du-vih-et-son-cycle-de-replication',
            category: 0,
            sub_category: 0,
          },
          118: {
            title: 'Prévention ou éducation sexuelle : quelles différences ?',
            thumbnail: 0,
            link: '/prevention-ou-education-sexuelle-quelles-differences',
            category: 0,
            sub_category: 0,
          },
          4779830: {
            title: 'Essai fake news decrypt',
            thumbnail: 0,
            link: '/essai-fake-news-decrypt',
            category: 'Cancers',
            sub_category: 0,
          },
        },
        link: {
          uri: 'internal:/decryptage/nos-réponses',
          title: 'Accèder aux décryptages',
          options: [],
        },
      },
      question: {
        title: 'Est-il vrai que...?',
        text: 'Vous avez entendu une info santé et n’êtes pas sûr de sa véracité ? Posez la question à nos experts !',
        maximum_caracter_text: 'Saisir 500 caractères maximum',
        icon: 0,
        webform: {
          target_id: 'fake_news_question',
          default_data: 0,
          status: 'open',
          open: 0,
          close: 0,
          fields_uri: '/webform_rest/fake_news_question/fields',
          submit_uri: '/webform_rest/submit',
        },
        popin: {
          title: 'Titre popin',
          text: 'Texte popin',
          icon: 0,
        },
      },
      pedagogic: {
        title: 'À qui se fier ?',
        nodes: {
          361: {
            title: 'La structure du VIH et son cycle de réplication',
            thumbnail: 0,
            link: '/la-structure-du-vih-et-son-cycle-de-replication-0',
            chapo: 'Le VIH (Virus de l\'Immunodéficience Humaine) fait partie de la famille des rétrovirus, caractérisés par la présence d\'une enzyme, la transcriptase inverse.',
          },
          135667: {
            title: 'Transmission du Sida : vrais risques et idées fausses',
            thumbnail: 0,
            link: '/transmission-du-sida-vrais-risques-et-idees-fausses',
            chapo: 'Le VIH est présent dans toutes les sécrétions corporelles. Seuls&nbsp;<strong>5 liquides biologiques</strong>&nbsp;peuvent contenir suffisamment de virus pour permettre une transmission :&nbsp;<strong>le sang (y compris celui des règles), le sperme, le liquide pré-séminal, les sécrétions vaginales, le lait maternel</strong>.',
          },
        },
        link: {
          uri: 'internal:/decryptage/a-qui-se-fier',
          title: 'Bouton',
          options: [],
        },
      },
      dictionnary: {
        wordings: {
          title_fakenews_main: 'Bienvenue dans le service',
          subtitle_fakenews_main: '“fake news” de Santé.fr',
          btn_decryptage: 'Accéder aux décryptages',
          btn_pedagogie: 'Voir toute la rubrique',
          title_pedagogie: 'À qui se fier ?',
          title_decryptage_article: 'Sur le même thème',
          title_pedagogie_article: 'Dans la même rubrique',
          title_fakenews_decryptage: 'La rubrique décryptage',
          menu_main: 'Accueil Fake News',
          menu_decryptage: 'Décryptage Fake News',
          menu_pedagogie: 'A qui se fier ? Fake News',
        },
        fakenews_types: {
          4: 'Fake news - décryptage',
          5: 'Fake news - pédagogie',
        },
        categories_fake_news: {
          222233: {
            id: 222233,
            name: 'Nutrition / perte de poids',
          },
          222235: {
            id: 222235,
            name: 'Bien être / hygiène de vie',
          },
          222237: {
            id: 222237,
            name: 'Recherches et essais cliniques',
          },
          222239: {
            id: 222239,
            name: 'Médicaments et dispositifs médicaux',
          },
          222241: {
            id: 222241,
            name: 'Fin de vie',
          },
          222243: {
            id: 222243,
            name: 'Enfants',
            childs: {
              4441: {
                id: 4441,
                name: 'Enfants1',
              },
              4442: {
                id: 4442,
                name: 'Enfants2',
              },
              4443: {
                id: 4443,
                name: 'Enfants3',
              },
            },
          },
          222247: {
            id: 222247,
            name: 'Santé sexuelle',
          },
          222249: {
            id: 222249,
            name: 'Cancers',
          },
          222255: {
            id: 222255,
            name: 'Dépendances / addictions',
          },
          222257: {
            id: 222257,
            name: 'Covid-19',
          },
          222259: {
            id: 222259,
            name: 'Maladies infectieuses',
          },
          222261: {
            id: 222261,
            name: 'Vaccination',
          },
          222310: {
            id: 222310,
            name: 'Santé',
            childs: {
              222245: {
                id: 222245,
                name: 'Santé des femmes',
              },
              222251: {
                id: 222251,
                name: 'Santé mentale',
              },
              222253: {
                id: 222253,
                name: 'Santé environnementale',
              },
            },
          },
        },
      },
    };
  }
}
